import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert } from "lucide-react";
import api from "../../lib/api";

const LEVEL_STYLE = {
  expired: "border-error bg-red-50 text-red-900",
  critical: "border-error bg-red-50 text-red-900",
  warning: "border-amber-400 bg-amber-50 text-amber-900",
};

export default function DocumentAlerts() {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    api.get("/alerts/documents")
      .then(({ data }) => setAlerts(data.alerts || []))
      .catch(() => {});
  }, []);

  if (!alerts.length) return null;

  return (
    <div className="space-y-2 mb-8" data-testid="document-alerts">
      {alerts.map((a) => (
        <div key={`${a.key}-${a.expiry}`}
          className={`flex items-start gap-3 border-l-4 px-4 py-3 ${LEVEL_STYLE[a.level] || LEVEL_STYLE.warning}`}
          data-testid={`doc-alert-${a.key}`}>
          {a.level === "warning" ? <AlertTriangle size={16} className="mt-0.5 shrink-0" /> : <ShieldAlert size={16} className="mt-0.5 shrink-0" />}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium">{a.message}</p>
            <p className="text-xs mt-0.5 opacity-80">
              Update in your <Link to="/you/profile" className="underline">Travel Profile</Link>
              {" · "}manage alerts in <Link to="/you/notifications" className="underline">Settings</Link>
            </p>
          </div>
          {a.trip_name && (
            <Link to={`/trips/${a.trip_id}`} className="font-mono text-[10px] uppercase tracking-wide underline shrink-0" data-testid={`doc-alert-trip-${a.key}`}>
              View trip
            </Link>
          )}
        </div>
      ))}
    </div>
  );
}
